import { render } from "./App.vue?vue&type=template&id=5c2740c6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5c2740c6&lang=scss"
script.render = render

export default script